import { TAccount } from './accounts.types';
import { getAccountFundedFormalOffer } from './getAccountFundedFormalOffer';

/**
 * Determines if an account is a funding for an interest-only account
 * @param account: TAccount- An Account object
 * @returns true or false
 */
export const getAccountIsInterestOnly = (account: TAccount) => {
    const fundedOffer = getAccountFundedFormalOffer(account);
    if (!fundedOffer) return false;
    return Boolean(
        fundedOffer.interest_only_repayments &&
            fundedOffer.interest_only_repayments > 0
    );
};
